module.exports = __webpack_public_path__ + "img/18.0ba119b5.png";